<template>
	<a-modal title="审批记录" style="top: 20px" width="95%" v-model="visible" :footer="null" :maskClosable="false">
		<a-table ref="table" rowKey="id" :loading="loading" :columns="columns" :dataSource="taskList">
			<span slot="serial" slot-scope="text, record, index">
				{{ index + 1 }}
			</span>
			<span slot="auditor" slot-scope="text">
				{{ text ? text.substr(0, text.indexOf('-')) : '' }}
			</span>
			<span slot="result" slot-scope="text" class="tag_class" :style="{ background: text ? result_apply[text].color : 'orange' }">
				{{ text | resultFilter }}
			</span>

			<span slot="action" slot-scope="text, record">
				<a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
				<a-divider type="vertical" />
				<a v-if="addEnable" @click="handleAdd(record.menuId + '')">新增</a>
				<a-divider type="vertical" />
				<a v-if="removeEnable" @click="delById(record.menuId)">删除</a>
			</span>
		</a-table>
		<div class="stpe_box">
			<div class="stpe_item" v-for="(item, index) in stpes" :key="index">
				<div class="center">
					<div class="center_val" :style="{ background: item.flag ? color : '' }">
						<div class="item" :style="{ color: item.flag ? '#fff' : '' }">{{ item.name }}</div>
						<div class="item minItem" :style="{ color: item.flag ? '#fff' : '' }">
							<div class="auditor" v-for="(item1, index ) in item.auditorRrr" :key="index">{{item1}}</div>
						</div>
						<div class="item minItem" :style="{ color: item.flag ? '#fff' : '' }">{{ item.endTime }}</div>
						<div class="records" v-for="(user, idx) in item.records" :key="idx">
							<div class="recordsTop" :style="{ color: item.flag ? '#fff' : '' }">
								{{ user.source }}转交至{{ user.target }}
							</div>
							<div class="recordsTop" :style="{ color: item.flag ? '#fff' : '' }">{{ user.createTime }}</div>
							<div class="recordsTop" :style="{ color: item.flag ? '#fff' : '' }">{{ user.reason }}</div>
						</div>
						<div class="item" v-if="item.duration" :style="{ color: item.flag ? '#fff' : '' }">本次审批共耗时：{{ item.duration }}</div>
					</div>
				</div>
				<div class="stepRound" :style="{ background: item.flag ? color : '' }"></div>
				<div class="stepLine" :style="{ background: item.flag ? color : '' }" v-if="index != stpes.length - 1"></div>
			</div>
		</div>
		
		<div>
			<div>
				<div style="font-weight: 600;font-size: 16px;margin-bottom: 10px;">
					流程评论
				</div>
				<div style="width: 100%;display: flex;height: 94px;">
					<a-textarea placeholder="请输入评论内容，100字以内" maxlength=101 :auto-size="{ minRows: 4, maxRows: 4 }" @input="numberChange" v-model="comment" />
					<a-button type="primary" style="height: 100%;" @click="oncomment">
						评论
					</a-button>
				</div>
				<div v-for="(item, index) in commentList" :key="index" style="border-bottom: 1px solid #e8e8e8;padding:20px;width: 100%;height:100%;">
					<div style="display: flex;justify-content: space-between;">
						<div style="font-weight: 600;font-size: 16px;">
							{{item.userName}}
						</div>
						<div>
							{{item.createTime}}
						</div>
					</div>
					<div style="margin-top: 10px;display: flex;justify-content: space-between;">
						<div v-html="item.comment.replace(/\n/g,'<br/>')" :style="{color:(item.delFlag==0?'black':'lightgray')}">
						</div>
						<div style="color: #99ADDF;cursor:pointer" @click="withdraw(item)" v-if="item.delFlag==0&&item.userId==$store.getters.userInfo.userId">
							撤回
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <img style="" :src="procFlowUrl" /> status="error"-->
	
	</a-modal>
</template>
<script>
	import {
		millsToTime
	} from '@/utils/util'
	import {
		getTaskFlow,
		get_process_all,
		comment,
		comment_delete
	} from '@/api/activiti'
	const resultMap = {
		1: '处理中',
		2: '通过',
		3: '驳回',
		4: '撤销',
	}

	export default {
		name: 'ProcFlowModal',
		props: {},
		components: {},
		data() {
			return {
				// 耗时总计
				duration: '',
				commentCount:'',
				commentlist:[],
				comment:'',
				visible: false,
				loading: false,
				procFlowUrl: '',
				taskList: [],
				// 表头
				columns: [{
						title: '序号',
						scopedSlots: {
							customRender: 'serial',
						},
					},
					{
						title: '申请标题',
						dataIndex: 'title',
						ellipsis: true,
					},
					{
						title: '审批节点',
						dataIndex: 'taskName',
						ellipsis: true,
					},
					{
						title: '审批人',
						dataIndex: 'auditor',
						scopedSlots: {
							customRender: 'auditor',
						},
					},
					{
						title: '审批意见',
						dataIndex: 'comment',
						ellipsis: true,
					},
					{
						title: '审批结果',
						dataIndex: 'result',
						scopedSlots: {
							customRender: 'result',
						},
					},
					{
						title: '耗时',
						dataIndex: 'duration',
						customRender: (text) => millsToTime(text),
					},
					{
						title: '下发时间',
						dataIndex: 'startTime',
						ellipsis: true,
					},
					{
						title: '审批时间',
						dataIndex: 'endTime',
						ellipsis: true,
					},
				],
				currentNumber: '',
				stpes: [],
				dataStepList: [],
				color: '',
				userId: '',
				rowlist:[],
				dataList: []
			}
		},
		beforeCreate() {},
		created() {},
		filters: {
			resultFilter(type) {
				return type ? resultMap[type] : '待审批'
			},
		},
		methods: {
			numberChange() {
				// console.log(this.comment.length, 'this.comment.length=============================')
				if(this.comment.length >= 100){
					// console.log(this.comment)
					this.comment =  this.comment.substr(0, 100)
					this.$message.warning('当前字数为100个字，不可超过100个字')
				}
				// console.log(this.comment.length, 'this.comment.length=============================')
			},
			withdraw(item){
				comment_delete(item.id).then(res=>{
					if (res.code == 200) {
						this.$message.success('撤回成功')
						this.show(this.rowlist)
					} else {
						this.$message.error(res.msg)
						return
					}
				})
			},
			oncomment(){
				if (!this.comment.trim()) {
					this.$message.error('评论不能为空')
					return
				}
				comment({
					procInstId:this.rowlist.procInstId,
					userId:this.$store.getters.userInfo.userId,
					comment:this.comment,
				}).then(res=>{
					if (res.code == 200) {
						this.$message.success('评论成功')
						this.show(this.rowlist)
					} else {
						this.$message.error(res.msg)
						return
					}
				})
			},
			show(row) {
				this.comment=''
				this.rowlist=row
				this.loading = true
				this.taskList = []
				get_process_all({
					procInstId: row.procInstId,
					name: row.procDefKey,
					userId: this.$store.getters.userId,
				}).then((res) => {
					console.log(res, 'res.history11111111111111111111111111111111111111111111')
					console.log(res.data.history, 'res.history11111111111111111111111111111111111111111111')
					if(res.data.history.length == 0) {
						this.taskList = res.data.history = []
					
					
					} else {
						this.dataList = res.data
						this.duration = millsToTime(res.data.duration)
					
						this.taskList = res.data.history
						console.log(this.taskList, 'this.taskList11111111111111111111111111111111111111111111')
						

					}
					
					this.commentCount=res.data.commentCount
					this.commentList=res.data.commentList
					
					var flows = res.data.tasks
					var result = 0
					for (let i = 0, l = flows.length; i < l; i++) {
						if (i + 1 < flows.length) {
							if (flows[i + 1].flag) {
								flows[i]['is_line'] = true
							}
						}
						if (flows[i].result == 3) {
							result = 3
						} else if (flows[i].result == 2) {
							result = 2
						} else if (flows[i].result == 4) {
							result = 4
						}
					}
					flows.forEach((item) => {
						item['result'] = result
					   Object.assign(item, {
						auditorRrr: item.auditor.split('、')
					   })
						
					})
					if (result == 3) {
						this.color = '#F56C6C'
					} else if (result == 2) {
						this.color = '#5B8FF9'
					} else if (result == 4) {
						this.color = '#CCCCCC'
					} else {
						this.color = '#5B8FF9'
					}
					this.stpes = flows
				


					

				})
							// hightlightFlow(procInstId).then(data => {
							// 	const raw = data.data
							// 	this.procFlowUrl = URL.createObjectURL(raw)
							// })
							this.visible = true
						// }
					// })
					// .finally((this.loading = false))
					this.loading = false
			},
		},
		watch: {
			/*
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			  */
		},
	}
</script>
<style lang="less" scoped>
.box {
	display: flex;
    flex-direction: row-reverse;
}
.auditor{
	text-align: left;

}
	::v-deep .ant-modal-content {
		float: left;
	}

	.stpe_box {
		width: 100%;
		float: left;
		margin-bottom: 50px;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		margin-top: 50px;

		.stpe_item {
			float: left;
			width: 100%;
			max-width: 300px;
			position: relative;
			

			.center {
				width: 100%;
				padding: 0 15px;
				box-sizing: border-box;
				max-width: 300px;
				float: left;
				text-align: left;

				.center_val {
					width: 100%;
					max-width: 300px;
					border-radius: 8px;
					float: left;
					padding: 5px 8px;
					box-sizing: border-box;
					background: #eee;
					min-height: 72px;
				}

				.item {
					width: 100%;
					float: left;
				}

				.minItem {
					font-size: 13px;
				}

				.records {
					width: 100%;
					float: left;
					font-size: 13px;
					margin-top: 10px;

					.recordsTop {
						width: 100%;
						float: left;
					}
				}
			}

			.arrow {
				width: 50px;
				float: left;
				font-size: 18px;
				height: 30px;
				display: flex;
				justify-content: center;
				align-items: center;
			}

			.stepRound {
				position: absolute;
				left: 50%;
				top: -30px;
				width: 24px;
				height: 24px;
				background: #999;
				border-radius: 50%;
				transform: translateX(-50%);
				z-index: 5;
			}

			.stepLine {
				position: absolute;
				left: 50%;
				top: -20px;
				width: 100%;
				height: 2px;
				background: #eee;
			}
		}
	}
</style>
